import React, { useEffect, useState } from "react";

const COOKIE_CONSENT_NAME = "cookie_consent";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
const MORE_INFO_HREF = "/docs/01_Политика_обработки_персональных_данных.pdf";

function hasCookieConsent() {
    return document.cookie
        .split(";")
        .map((item) => item.trim())
        .some((item) => item === `${COOKIE_CONSENT_NAME}=accepted`);
}

export function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(!hasCookieConsent());
    }, []);

    const handleAccept = () => {
        document.cookie = `${COOKIE_CONSENT_NAME}=accepted; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="fixed inset-x-4 bottom-4 z-50 mx-auto w-auto max-w-[671px] rounded-[28px] bg-white px-5 py-5 text-black shadow-[0_20px_80px_rgba(0,0,0,0.35)] sm:inset-x-auto sm:right-6 sm:bottom-6 sm:rounded-[40px] sm:px-[42px] sm:py-6">
            <div className="flex flex-col gap-3 sm:min-h-[216px] sm:justify-between sm:gap-[10px]">
                <p className="m-0 text-[16px] leading-[1] font-medium tracking-[0] sm:text-[21px]">
                    Мы используем файлы cookie и данные сервисов веб-аналитики, собираемые
                    посредством «Яндекс Метрика». Нажимая на кнопку «Я согласен», или продолжая
                    использовать сайт, Вы соглашаетесь с обработкой таких данных на условиях
                    Политики cookie.{" "}
                    <a
                        href={MORE_INFO_HREF}
                        className="text-[#1877F2] underline decoration-[1.5px] underline-offset-4"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Больше информации здесь.
                    </a>
                </p>
                <div>
                    <button
                        type="button"
                        className="inline-flex h-[42px] min-w-[140px] items-center justify-center rounded-[12px] bg-[#96EA28] px-6 py-3 text-[18px] leading-[1] font-medium tracking-[-0.04em] text-black transition hover:brightness-95"
                        onClick={handleAccept}
                    >
                        Я согласен
                    </button>
                </div>
            </div>
        </div>
    );
}
